import { createSlice } from "@reduxjs/toolkit";

export const companyDataSlice = createSlice({
  name: "companyData",
  initialState: {
    data: null, 
    error: null,
    isLoading: false
  },
  reducers: {
    startCompanyData: (state) => { state.isLoading = true; },
    setCompanyData: (state, { payload: { data = null, error = null}}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startCompanyData, setCompanyData } = companyDataSlice.actions;
